<template>
    <div class="myPage91">
        <div class="searchBigBox m_width m_mar0a m_flex m_aic m_jcsb" @mouseenter="hoverTopMenu('关闭')">
            <div class="searchLeftBox m_flex m_aic">
                <img src="@/assets/images/logo.png" @click="goIndexPage" class="logo" alt="" />
                <div class="searchBarBox m_flex m_aic m_jcsb">
                <div class="leftBox m_flex1 m_flex m_aic m_jcc">
                    <div class="selectBox m_flex m_aic m_jcsb">
                        <div class="text m_flex1 m_line_1">
                            {{ selectList[selectIndex]['name'] }}
                        </div>
                        <i class="el-icon-arrow-down icon"></i>
                        <input type="text" @blur="selectBtnFun('失去焦点')" @focus="selectBtnFun('聚焦')" class="itemBoxInput" />
                        <!-- 下拉菜单 -->
                        <div class="selectBigBox" v-show="selectShow">
                            <div
                                class="itemBox m_flex m_aic"
                                :class="{ active: index == selectIndex }"
                                v-for="(item, index) in selectList"
                                :key="item.id"
                                @click="selectSearch(index)"
                            >
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                    <div class="lineGrey"></div>
                    <input
                        type="text"
                        class="inputStyle m_flex1"
                        placeholder="输入品名，货号或CAS号等"
                        @blur="inputFun('失去焦点')"
                        @focus="inputFun('聚焦')"
                        v-model="keyword"
                    />

                    <!-- 搜索下拉 -->
                    <div class="searchWin" v-show="inputWinShow">
                        <div class="hintText">提示：可直接搜索产品货号或SKU（例如，t1503或t1503-25g），将产品直接加入购物车。</div>
                        <div class="hintText2" v-if="$store.state.header_search_history.length > 0">最近的检索内容</div>
                        <div class="winGreyLine" v-if="$store.state.header_search_history.length > 0"></div>
                        <div
                            class="searchText"
                            v-for="(item, index) in $store.state.header_search_history"
                            @click="handleSearchHistory(item)"
                            :key="index"
                        >
                            {{ item }}
                        </div>
                        <!-- <div class="redText" @click="goSearchList">高级检索</div> -->
                    </div>
                </div>
                <div class="searchIconBox m_flex m_aic m_jcc" @click="searchFun">
                    <i class="el-icon-search icon"></i>
                </div>
            </div>
            </div>
            <!-- 语言选择器 -->
            <div class="languageSelectorWrapper">
                <span class="countrySelector">
                    <svg class="languageIcon" focusable="false" aria-hidden="true" viewBox="0 0 24 24">
                        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2m6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56M12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56m2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8M12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96M14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2m.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56M16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2z"></path>
                    </svg>
                    CN
                </span>
                <div class="languageDivider"></div>
                <button 
                    class="languageSelectorBtn" 
                    type="button" 
                    @click="toggleLanguageMenu"
                    @blur="closeLanguageMenu"
                >
                    {{ currentLanguage }}
                    <svg class="languageIcon arrowIcon" focusable="false" aria-hidden="true" viewBox="0 0 24 24">
                        <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"></path>
                    </svg>
                </button>
                <!-- 语言下拉菜单 -->
                <div class="languageMenu" v-show="languageMenuShow">
                    <div
                        class="languageMenuItem"
                        v-for="(lang, index) in languageList"
                        :key="index"
                        :class="{ active: lang.code === currentLanguage }"
                        @click="selectLanguage(lang)"
                    >
                        {{ lang.name }} ({{ lang.code }})
                    </div>
                </div>
            </div>
        </div>

        <!-- 红色导航 -->
        <div class="redBox m_flex m_aic m_jcc">
            <div class="redFlexBox m_width m_flex m_aic m_jcsb">
                <div class="leftBox m_flex m_aic m_jcs">
                    <div class="btnBigBox m_flex m_aic m_jcs" :class="{ active: topMenuActive == '产品' }" @mouseenter="hoverTopMenu('产品')">
                        <div class="btnText">产品</div>
                        <img src="@/assets/images/down.png" class="downIcon" alt="" />
                        <img src="@/assets/images/down2.png" class="downIcon2" alt="" />
                    </div>
                    <div class="btnBigBox m_flex m_aic m_jcs" :class="{ active: topMenuActive == '应用' }" @mouseenter="hoverTopMenu('应用')">
                        <div class="btnText">应用</div>
                        <img src="@/assets/images/down.png" class="downIcon" alt="" />
                        <img src="@/assets/images/down2.png" class="downIcon2" alt="" />
                    </div>
                    <div class="btnBigBox m_flex m_aic m_jcs" :class="{ active: topMenuActive == '服务' }" @mouseenter="hoverTopMenu('服务')">
                        <div class="btnText">服务</div>
                        <img src="@/assets/images/down.png" class="downIcon" alt="" />
                        <img src="@/assets/images/down2.png" class="downIcon2" alt="" />
                    </div>
                    <div class="btnBigBox m_flex m_aic m_jcs" :class="{ active: topMenuActive == '文件' }" @mouseenter="hoverTopMenu('文件')">
                        <div class="btnText">文件</div>
                        <img src="@/assets/images/down.png" class="downIcon" alt="" />
                        <img src="@/assets/images/down2.png" class="downIcon2" alt="" />
                    </div>
                    <div class="btnBigBox m_flex m_aic m_jcs" :class="{ active: topMenuActive == '支持' }" @mouseenter="hoverTopMenu('支持')">
                        <div class="btnText">支持</div>
                        <img src="@/assets/images/down.png" class="downIcon" alt="" />
                        <img src="@/assets/images/down2.png" class="downIcon2" alt="" />
                    </div>
                </div>

                <div class="rightBox m_flex m_aic m_jce" @mouseenter="hoverTopMenu('关闭')">
                    <div class="btnBigBox2 m_flex m_aic m_jcs">
                        <div class="btnText" v-if="!vuex_isLogin">登录</div>
                        <div class="btnText" v-if="vuex_isLogin">尊敬的{{ vuex_userInfo.firstName }}</div>
                        <img src="@/assets/images/down.png" class="downIcon" alt="" />
                        <img src="@/assets/images/down2.png" class="downIcon2" alt="" />
                        <div class="btnWin m_shadow" v-if="!vuex_isLogin">
                            <div class="logoBtn m_flex m_aic m_jcc btn-ripple" @click="goLogin">登录</div>
                            <div class="blackLine"></div>
                            <div class="hintText">暂无账户？</div>
                            <div class="signBtn m_flex m_aic m_jcc btn-ripple" @click="goRegister">注册</div>
                        </div>
                        <div class="btnWin2 m_shadow" v-if="vuex_isLogin">
                            <div class="btnWin2LineBox">欢迎您 {{ vuex_userInfo.firstName }}</div>
                            <div class="greyLine3"></div>
                            <div class="btnWin2LineBox2" @click="winGoPage('我的个人资料')">我的个人资料</div>
                            <div class="greyLine3"></div>
                            <div class="btnWin2LineBox2" @click="winGoPage('登录/注册')">登录/注册</div>
                            <div class="btnWin2LineBox2" @click="winGoPage('我的订单')">我的订单</div>
                            <div class="btnWin2LineBox2" @click="winGoPage('再次购买')">再次购买</div>
                            <div class="btnWin2LineBox2" @click="winGoPage('已保存购物车')">已保存购物车</div>
                            <div class="btnWin2LineBox2" @click="winGoPage('报价')">报价</div>
                            <div class="btnWin2LineBox2" @click="winGoPage('清单')">清单</div>
                            <div class="greyLine3"></div>
                            <div class="btnWin2LineBox2" @click="winGoPage('Emprove®计划')">Emprove®计划</div>
                            <div class="btnWin2LineBox2" @click="winGoPage('文档库')">文档库</div>
                            <div class="btnWin2LineBox2" @click="winGoPage('软件库')">软件库</div>
                            <div class="greyLine3"></div>
                            <!-- <div class="btnWin2LineBox2" @click="winGoPage('邀请同事')">邀请同事</div> -->
                            <div class="btnWin2LineBox2 mb0" @click="winGoPage('登出')">登出</div>
                        </div>
                    </div>
                    <div class="whiteLine2"></div>
                    <div class="textBtn" @click="goOrder">订单查询</div>
                    <div class="whiteLine"></div>
                    <div class="textBtn" @click="goQuickOrder">快速订购</div>
                    <div class="whiteLine"></div>
                    <div class="buyCarBox m_flex m_aic m_jcc" @click="goCartPage">
                        <img src="@/assets/images/buyCar.png" class="buyCar" alt="" />
                        <div class="buyText">购物车</div>
                        <div class="numBox m_flex m_aic m_jcc">
                            <div class="num">{{ vuex_userInfo.cartNum ? vuex_userInfo.cartNum : '0' }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 产品 -->
            <div class="productWin m_shadow" ref="productWin" v-if="topMenuActive == '产品'">
                <div class="bigBox m_width m_flex m_ais m_jcs">
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '一级')"
                            v-for="(item, index) in topMenuList"
                            :key="index"
                            @click="goPage(item, 1)"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex == index }">{{ item.title }}</div>
                            <img src="@/assets/images/right.png" v-if="item.channels.length > 0" class="right" alt="" />
                        </div>
                    </div>
                    <div class="greyLineBox"></div>
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '二级')"
                            v-for="(item, index) in topMenuListLevel2"
                            :key="index"
                            @click="goPage(item, 2)"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex2 == index }">{{ item.title }}</div>
                            <img src="@/assets/images/right.png" v-if="item.channels.length > 0" class="right" alt="" />
                        </div>
                    </div>
                    <div class="greyLineBox"></div>
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '三级')"
                            v-for="(item, index) in topMenuListLevel3"
                            :key="index"
                            @click="goPage(item, 3)"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex3 == index }">{{ item.title }}</div>
                            <!-- <img src="@/assets/images/right.png" class="right" alt="" /> -->
                        </div>
                    </div>
                </div>
                <div class="closeWin"></div>
            </div>

            <!-- 应用 -->
            <div class="productWin m_shadow" ref="productWin2" v-if="topMenuActive == '应用'">
                <div class="bigBox m_width m_flex m_ais m_jcs">
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '一级')"
                            v-for="(item, index) in topMenuList2"
                            :key="index"
                            @click="goPage2(item, 1)"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex == index }">{{ item.title }}</div>
                            <img src="@/assets/images/right.png" v-if="item.child && item.child.length > 0" class="right" alt="" />
                        </div>
                    </div>
                    <div class="greyLineBox"></div>
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '二级')"
                            v-for="(item, index) in topMenuList2Level2"
                            :key="index"
                            @click="goPage2(item, 2)"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex2 == index }">{{ item.title }}</div>
                            <img src="@/assets/images/right.png" v-if="item.child && item.child.length > 0" class="right" alt="" />
                        </div>
                    </div>
                    <div class="greyLineBox"></div>
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '三级')"
                            v-for="(item, index) in topMenuList2Level3"
                            :key="index"
                            @click="goPage2(item, 3)"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex3 == index }">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
                <div class="closeWin"></div>
            </div>

            <!-- 服务 -->
            <div class="productWin m_shadow" ref="productWin3" v-if="topMenuActive == '服务'">
                <div class="bigBox m_width m_flex m_ais m_jcs">
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '一级')"
                            v-for="(item, index) in topMenuList3"
                            :key="index"
                            @click="goPage3(item, 1)"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex == index }">{{ item.title }}</div>
                            <img src="@/assets/images/right.png" v-if="item.child.length > 0" class="right" alt="" />
                        </div>
                    </div>
                    <div class="greyLineBox"></div>
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '二级')"
                            v-for="(item, index) in topMenuList3Level2"
                            :key="index"
                            @click="goPage3(item, 2)"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex2 == index }">{{ item.title }}</div>
                            <img src="@/assets/images/right.png" v-if="item.child.length > 0" class="right" alt="" />
                        </div>
                    </div>
                    <div class="greyLineBox"></div>
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '三级')"
                            v-for="(item, index) in topMenuList3Level3"
                            :key="index"
                            @click="goPage3(item, 3)"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex3 == index }">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
                <div class="closeWin"></div>
            </div>

            <!-- 文件 -->
            <div class="productWin m_shadow" ref="productWin4" v-if="topMenuActive == '文件'">
                <div class="bigBox m_width m_flex m_ais m_jcs">
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '一级')"
                            @click="goPage4(item)"
                            v-for="(item, index) in topMenuList4"
                            :key="index"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex == index }">{{ item.title }}</div>
                            <!-- <img src="@/assets/images/right.png" class="right" alt="" /> -->
                        </div>
                    </div>
                </div>
                <div class="closeWin"></div>
            </div>

            <!-- 支持 -->
            <div class="productWin m_shadow" ref="productWin5" v-if="topMenuActive == '支持'">
                <div class="bigBox m_width m_flex m_ais m_jcs">
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '一级')"
                            v-for="(item, index) in topMenuList5"
                            :key="index"
                            @click="goPage5(item)"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex == index }">{{ item.title }}</div>
                            <img src="@/assets/images/right.png" class="right" alt="" />
                        </div>
                    </div>
                    <div class="greyLineBox"></div>
                    <div class="lineBigBox">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '二级')"
                            v-for="(item, index) in topMenuList5Level2"
                            :key="index"
                            @click="goPage5(item)"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex2 == index }">{{ item.title }}</div>
                            <!-- <img src="@/assets/images/right.png" class="right" alt="" /> -->
                        </div>
                    </div>
                    <div class="greyLineBox"></div>
                    <div class="lineBigBox" v-if="false">
                        <div
                            class="nameBigBox m_flex m_aic m_jcsb"
                            @mouseenter="hoverMenu(item, index, '三级')"
                            v-for="(item, index) in 3"
                            :key="index"
                        >
                            <div class="nameBox" :class="{ bold: menuSelectIndex == index }">{{ item.title }}</div>
                            <!-- <img src="@/assets/images/right.png" class="right" alt="" /> -->
                        </div>
                    </div>
                </div>
                <div class="closeWin"></div>
            </div>
        </div>

        <div class="productWinCloseBox" v-show="topMenuActive" @mouseenter="hoverTopMenu('关闭')"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectShow: false,
            selectList: [
                {
                    id: 1,
                    name: '产品',
                },
                {
                    id: 2,
                    name: '技术文档',
                },
                {
                    id: 3,
                    name: '网站内容',
                },
                {
                    id: 4,
                    name: '论文',
                },
            ],
            selectIndex: 0,

            inputWinShow: false, // 搜索输入框下的弹窗

            topMenuActive: '', // 顶部激活的菜单

            menuSelectIndex: -1, // 菜单一级选中的下标
            menuSelectIndex2: -1, // 菜单二级选中的下标
            menuSelectIndex3: -1, // 菜单三级选中的下标

            topMenuList: [], // 产品
            topMenuList2: [], // 应用
            topMenuList3: [], // 服务
            topMenuList4: [
                {
                    title: '安全说明书（MSDS）',
                    path: '/file-search?tab=1',
                },
                {
                    title: '分析证书（COA）',
                    path: '/file-search?tab=2',
                },
                {
                    title: '原产地证书',
                    path: '/file-search?tab=3',
                },
                {
                    title: '安全标签',
                    path: '/file-search?tab=4',
                },
                {
                    title: '技术标准',
                    path: '/file-search?tab=5',
                },
            ], // 文件
            topMenuList5: [], // 支持
            hoverTopMenuIndex: [-1, -1],

            keyword: '',

            // 语言选择器相关
            languageMenuShow: false, // 语言菜单显示状态
            currentLanguage: 'ZH', // 当前语言代码
            languageList: [
                { code: 'ZH', name: '中文' },
                { code: 'EN', name: 'English' },
            ],
        }
    },
    created() {
        this.productMenu() // 获取产品顶部菜单
        this.applyMenu() // 获取应用顶部菜单
        this.supportMenu() // 获取支持顶部菜单
        this.serviceMenu() // 获取服务顶部菜单
    },
    computed: {
        topMenuListLevel2() {
            let topMenuList = this.topMenuList
            let menuSelectIndex = this.menuSelectIndex
            if (topMenuList[menuSelectIndex] && topMenuList[menuSelectIndex].channels && topMenuList[menuSelectIndex].channels.length > 0) {
                return topMenuList[menuSelectIndex].channels
            } else {
                return []
            }
        },
        topMenuListLevel3() {
            let topMenuList = this.topMenuList
            let menuSelectIndex = this.menuSelectIndex
            let menuSelectIndex2 = this.menuSelectIndex2
            if (menuSelectIndex == -1 || menuSelectIndex2 == -1) {
                return []
            }
            if (topMenuList[menuSelectIndex].channels && topMenuList[menuSelectIndex].channels.length > 0) {
                let childList = topMenuList[menuSelectIndex].channels[menuSelectIndex2].channels
                return childList
            } else {
                return []
            }
        },
        topMenuList3Level2() {
            let topMenuList3 = this.topMenuList3
            let menuSelectIndex = this.menuSelectIndex
            if (topMenuList3[menuSelectIndex] && topMenuList3[menuSelectIndex].child && topMenuList3[menuSelectIndex].child.length > 0) {
                return topMenuList3[menuSelectIndex].child
            } else {
                return []
            }
        },
        topMenuList3Level3() {
            let topMenuList3 = this.topMenuList3
            let menuSelectIndex = this.menuSelectIndex
            let menuSelectIndex2 = this.menuSelectIndex2
            if (menuSelectIndex == -1 || menuSelectIndex2 == -1) {
                return []
            }
            if (topMenuList3[menuSelectIndex].child && topMenuList3[menuSelectIndex].child.length > 0) {
                let childList = topMenuList3[menuSelectIndex].child[menuSelectIndex2].child
                return childList
            } else {
                return []
            }
        },
        topMenuList2Level2() {
            let topMenuList2 = this.topMenuList2
            let menuSelectIndex = this.menuSelectIndex
            if (topMenuList2[menuSelectIndex] && topMenuList2[menuSelectIndex].child && topMenuList2[menuSelectIndex].child.length > 0) {
                return topMenuList2[menuSelectIndex].child
            } else {
                return []
            }
        },
        topMenuList2Level3() {
            let topMenuList2 = this.topMenuList2
            let menuSelectIndex = this.menuSelectIndex
            let menuSelectIndex2 = this.menuSelectIndex2
            if (menuSelectIndex == -1 || menuSelectIndex2 == -1) {
                return []
            }
            if (topMenuList2[menuSelectIndex].child && topMenuList2[menuSelectIndex].child.length > 0) {
                let childList = topMenuList2[menuSelectIndex].child[menuSelectIndex2].child
                return childList
            } else {
                return []
            }
        },
        topMenuList5Level2() {
            let topMenuList5 = this.topMenuList5
            let menuSelectIndex = this.menuSelectIndex
            if (topMenuList5[menuSelectIndex] && topMenuList5[menuSelectIndex].child) {
                return topMenuList5[menuSelectIndex].child
            } else {
                return []
            }
        },
        topMenuList5CheckIsNavShow() {
            return (obj) => {
                function hasNavShowOneInChild(obj) {
                    if (!obj || typeof obj !== 'object') {
                        return false
                    }

                    // 检查当前对象的 child 属性
                    if (Array.isArray(obj.child)) {
                        for (const item of obj.child) {
                            if (item.isNavShow === 1) {
                                return true
                            }

                            // 递归检查子项的 child 属性
                            if (hasNavShowOneInChild(item)) {
                                return true
                            }
                        }
                    }

                    return false
                }

                return hasNavShowOneInChild(obj)
            }
        },
    },
    mounted() {},
    methods: {
        handleSearchHistory(item) {
            this.$router.push({
                path: '/search-result',
                query: {
                    type: this.selectList[this.selectIndex].id,
                    keyword: item,
                },
            })
            this.keyword = ''
        },
        searchFun() {
            /**
             * 确保数组长度不超过10，超过则保留前10个元素
             */
            function limitArrayToFirst10(arr) {
                // 检查输入是否为数组
                if (!Array.isArray(arr)) {
                    throw new Error('输入必须是一个数组')
                }

                // 如果数组长度大于10，则保留前10个元素，否则返回原数组
                return arr.length > 10 ? arr.slice(0, 10) : arr
            }
            if (!this.keyword) {
                return
            }
            let header_search_history = this.$cloneDeep(this.$store.state.header_search_history)
            header_search_history.unshift(this.keyword)
            this.mix_setVuex('header_search_history', limitArrayToFirst10(header_search_history))
            this.$router.push({
                path: '/search-result',
                query: {
                    type: this.selectList[this.selectIndex].id,
                    keyword: this.keyword,
                },
            })
            this.keyword = ''
        },
        goSearchList() {
            this.$router.push({
                path: '/search',
            })
        },
        async productMenu() {
            let res = await this.api_product_channel({
                parentId: '',
            })
            if (res.code == 200) {
                this.topMenuList = res.data
            } else {
                alertErr(res.msg)
            }
        },
        async serviceMenu() {
            let res = await this.api_service_channel({
                channelId: '',
            })
            if (res.code == 200) {
                this.topMenuList3 = res.data
            } else {
                alertErr(res.msg)
            }
        },
        async applyMenu() {
            let res = await this.api_apply_getApplyChannelList({
                channelId: '',
            })
            if (res.code == 200) {
                this.topMenuList2 = res.data
            } else {
                alertErr(res.msg)
            }
        },
        async supportMenu() {
            // 使用 support API 获取支持分类数据
            let res = await this.api_support_channel({
                channelId: 0,
            })
            if (res.code == 200) {
                this.topMenuList5 = res.data
            } else {
                alertErr(res.msg)
            }
        },
        // 产品跳转
        goPage(item, level) {
            this.$router.push({
                path: '/products',
                query: {
                    id: item.id,
                },
            })
        },
        // 应用跳转
        goPage2(item, level) {
            if (this.$isArray(item.child) && item.child.length > 0) {
                // 去列表页面，有子集
                if (level == 1) {
                    this.$router.push({
                        name: 'applications',
                        params: {
                            enName: item.tag,
                        },
                    })
                } else if (level == 2) {
                    this.$router.push({
                        name: 'applications2',
                        params: {
                            enName: this.topMenuList2[this.menuSelectIndex]['tag'],
                            enName2: item.tag,
                        },
                    })
                }
            } else {
                // 去详情页，无子集
                this.$router.push({
                    name: 'applicationsDetail',
                    params: {
                        enName: item.tag,
                    },
                })
            }
            this.$refs.productWin2.style.display = 'none'
        },
        // 服务跳转
        goPage3(item, level) {
            this.$router.push({
                name: 'services',
                params: {
                    enName: item.route,
                },
            })
            // if (this.$isArray(item.child) && item.child.length > 0) {
            //     // 去列表页面，有子集
            //     if (level == 1) {
            //         this.$router.push({
            //             name: 'services',
            //             params: {
            //                 enName: item.route,
            //             },
            //         })
            //     } else if (level == 2) {
            //         this.$router.push({
            //             name: 'services2',
            //             params: {
            //                 enName: this.topMenuList3[this.menuSelectIndex]['route'],
            //                 enName2: item.route,
            //             },
            //         })
            //     }
            // } else {
            //     // 去详情页，无子集
            //     this.$router.push({
            //         name: 'servicesDetail',
            //         params: {
            //             enName: item.route,
            //         },
            //     })
            // }
            this.$refs.productWin3.style.display = 'none'
        },
        // 文件跳转
        goPage4(item) {
            this.$router.push({
                path: item.path,
            })
            this.$refs.productWin4.style.display = 'none'
        },
        // 支持跳转 - 使用 support 系统数据
        goPage5(item) {
            this.$refs.productWin5.style.display = 'none'
            // 优先使用 route，如果 route 为空则使用 id
            let targetId = item.route || item.id

            if (item.child && item.child.length > 0) {
                // 有子分类，跳转到第一个子分类
                let firstChild = item.child[0]
                this.$router.push({
                    name: 'article',
                    params: {
                        name: firstChild.route || firstChild.id,
                    },
                })
                return
            } else {
                // 无子分类，直接跳转
                this.$router.push({
                    name: 'article',
                    params: {
                        name: targetId,
                    },
                })
            }
        },
        goQuickOrder() {
            this.$router.push({
                path: '/quick-order',
            })
        },
        goOrder() {
            if (!this.vuex_isLogin) {
                alertErr('请先登录')
                return
            }
            this.$router.push({
                path: '/order-search',
            })
        },
        goRegister() {
            this.$router.push({
                path: '/register',
            })
        },
        goLogin() {
            this.$router.push({
                path: '/login',
            })
        },
        // 去首页
        goIndexPage() {
            this.$router.push({
                path: '/',
            })
        },
        // 去购物车页面
        goCartPage() {
            if (!this.vuex_isLogin) {
                alertErr('请先登录')
                return
            }
            this.$store.commit('set_vuex_data', {
                k: 'vuex_cartWin',
                v: true,
            })
        },
        inputFun(text) {
            if (text == '聚焦') {
                this.inputWinShow = true
                return
            }

            if (text == '失去焦点') {
                setTimeout(() => {
                    this.inputWinShow = false
                }, 100)
                return
            }
        },
        selectSearch(index) {
            this.selectIndex = index
        },
        selectBtnFun(text) {
            if (text == '失去焦点') {
                setTimeout(() => {
                    this.selectShow = false
                }, 100)
                return
            }
            if (text == '聚焦') {
                this.selectShow = true
                return
            }
        },
        hoverMenu(item, index, text) {
            if (text == '一级') {
                this.menuSelectIndex = index
                this.menuSelectIndex2 = -1
                return
            }

            if (text == '二级') {
                this.menuSelectIndex2 = index
                this.menuSelectIndex3 = -1
                return
            }

            if (text == '三级') {
                this.menuSelectIndex3 = index
                return
            }
        },
        hoverTopMenu(text) {
            if (text == '关闭') {
                this.topMenuActive = ''
                return
            }

            this.topMenuActive = text
            if (text == '产品') {
                return
            }

            if (text == '应用') {
                return
            }

            if (text == '服务') {
                return
            }

            if (text == '文件') {
                return
            }

            if (text == '支持') {
                return
            }
        },
        winGoPage(text) {
            if (text == '我的个人资料') {
                this.$router.push({
                    path: '/mine',
                })
                return
            }
            if (text == '登录/注册') {
                this.$router.push({
                    path: '/account',
                })
                return
            }
            if (text == '我的订单') {
                this.$router.push({
                    path: '/order-search',
                })
                return
            }
            if (text == '再次购买') {
                this.$router.push({
                    path: '/buy-it-again',
                })
                return
            }
            if (text == '已保存购物车') {
                this.$router.push({
                    path: '/saved-carts',
                })
                return
            }
            if (text == '报价') {
                this.$router.push({
                    path: '/quotes',
                })
                return
            }
            if (text == '清单') {
                this.$router.push({
                    path: '/lists',
                })
                return
            }
            if (text == 'Emprove®计划') {
                return
            }
            if (text == '文档库') {
                this.$router.push({
                    path: '/documents-search',
                })
                return
            }
            if (text == '软件库') {
                return
            }
            if (text == '邀请同事') {
                this.$router.push({
                    path: '/invite-coworker',
                })
                return
            }
            if (text == '登出') {
                this.$store.commit('set_vuex_data', {
                    k: 'vuex_token',
                    v: '',
                })
                this.$store.commit('set_vuex_data', {
                    k: 'vuex_userId',
                    v: '',
                })
                this.$store.commit('set_vuex_data', {
                    k: 'vuex_isLogin',
                    v: false,
                })
                this.$store.commit('set_vuex_data', {
                    k: 'vuex_userInfo',
                    v: {},
                })
                alertSucc('已退出')
                this.$router.push({
                    path: '/',
                })
                return
            }
        },
        api_support_channel(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api('support_channel', obj).then((res) => {
                    resolve(res)
                })
            })
        },
        api_apply_getApplyChannelList(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api('apply_getApplyChannelList', obj).then((res) => {
                    resolve(res)
                })
            })
        },
        api_service_channel(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api('service_channel', obj).then((res) => {
                    resolve(res)
                })
            })
        },
        api_product_channel(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api('product_channel', obj).then((res) => {
                    resolve(res)
                })
            })
        },
        api_essay_getEssayChannelDetail(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api('essay_getEssayChannelDetail', obj).then((res) => {
                    resolve(res)
                })
            })
        },
        // 语言选择器相关方法
        toggleLanguageMenu() {
            this.languageMenuShow = !this.languageMenuShow
        },
        closeLanguageMenu() {
            setTimeout(() => {
                this.languageMenuShow = false
            }, 200)
        },
        selectLanguage(lang) {
            this.currentLanguage = lang.code
            this.languageMenuShow = false
            // 这里可以添加语言切换的逻辑，比如调用i18n切换语言
            // this.$i18n.locale = lang.code.toLowerCase()
            // 或者保存到localStorage
            localStorage.setItem('selectedLanguage', lang.code)
            // 可以触发事件通知其他组件语言已切换
            this.$emit('language-changed', lang)
        },
    },
    mounted() {
        // 从localStorage读取保存的语言设置
        const savedLanguage = localStorage.getItem('selectedLanguage')
        if (savedLanguage) {
            this.currentLanguage = savedLanguage
        }
    },
}
</script>

<style lang="less" scoped>
.myPage91 {
    width: 100%;
    position: relative;
    top: 0;
    left: 0;
    z-index: 99;

    .productWinCloseBox {
        width: 100%;
        height: calc(100vh - 108px - 48px);
        position: fixed;
        bottom: 0;
        left: 0;
    }

    .redBox {
        position: relative;
        width: 100%;
        height: 48px;
        background: #d61818;
        box-shadow: 0px 3px 8px 1px rgba(0, 0, 0, 0.16);

        .productWin {
            width: 100%;
            position: absolute;
            top: 48px;
            left: 0;
            background: #ffffff;
            z-index: 9;

            .closeWin {
                position: absolute;
                width: 100%;
                left: 0;
            }

            .bigBox {
                margin: 0 auto;
                padding: 30px;
                position: relative;

                .greyLineBox {
                    width: 2px;
                    height: 100%;
                    background: gray;
                    opacity: 0.1;
                    margin: 0 20px;
                }

                .lineBigBox {
                    width: 290px;
                    max-height: calc(100vh - 156px - 150px);
                    overflow-x: hidden;
                    overflow-y: auto;
                    /* Firefox */
                    scrollbar-width: none;
                    /* IE 和 Edge */
                    -ms-overflow-style: none;

                    /* WebKit 内核浏览器 */
                    &::-webkit-scrollbar {
                        display: none;
                    }

                    .nameBigBox {
                        width: 100%;
                        cursor: pointer;
                        margin-bottom: 20px;

                        .nameBox {
                            width: 250px;
                            font-weight: 400;
                            font-size: 16px;
                            color: #000000;
                            line-height: 21px;

                            &.bold {
                                font-weight: bold;
                            }
                        }

                        .right {
                            width: 14px;
                        }
                    }
                }
            }
        }

        .redFlexBox {
            height: 100%;

            .rightBox {
                height: 100%;

                .buyCarBox {
                    cursor: pointer;

                    .buyCar {
                        width: 22px;
                        margin-right: 8px;
                    }

                    .buyText {
                        font-weight: bold;
                        font-size: 14px;
                        color: #ffffff;
                        line-height: 20px;
                        text-align: left;
                        margin-right: 8px;
                    }

                    .numBox {
                        min-width: 23px;
                        padding: 0 4px;
                        height: 23px;
                        background: #ffffff;
                        border-radius: 4px 4px 4px 4px;

                        .num {
                            font-weight: bold;
                            font-size: 14px;
                            color: #d61818;
                            line-height: 19px;
                            text-align: left;
                        }
                    }
                }

                .btnBigBox2 {
                    height: 100%;
                    position: relative;
                    cursor: pointer;
                    padding: 0 16px;
                    background: transparent;

                    .btnText {
                        font-weight: bold;
                        font-size: 15px;
                        color: #ffffff;
                        line-height: 20px;
                    }

                    .downIcon {
                        width: 14px;
                        display: block;
                        margin-left: 4px;
                    }

                    .downIcon2 {
                        width: 14px;
                        display: block;
                        margin-left: 4px;
                        display: none;
                    }

                    .btnWin2 {
                        position: absolute;
                        top: 48px;
                        left: 0;
                        padding: 16px;
                        transition: 0.5s all;
                        width: 247px;
                        background: #ffffff;
                        display: none;

                        .btnWin2LineBox {
                            width: 100%;
                            font-weight: bold;
                            font-size: 16px;
                            color: #000000;
                            line-height: 24px;
                            text-align: left;
                        }

                        .greyLine3 {
                            width: 100%;
                            height: 1px;
                            background: lightgray;
                            margin: 10px 0;
                        }

                        .btnWin2LineBox2 {
                            width: 100%;
                            font-weight: normal;
                            font-size: 16px;
                            color: #000000;
                            line-height: 24px;
                            text-align: left;
                            margin-bottom: 8px;

                            &.mb0 {
                                margin-bottom: 0;
                            }
                        }
                    }

                    .btnWin {
                        display: none;
                        width: 248px;
                        height: 239px;
                        background: #ffffff;
                        box-shadow: 0px 6px 6px 1px rgba(0, 0, 0, 0.3);
                        position: absolute;
                        top: 48px;
                        left: 0;
                        padding: 32px 16px 0 16px;
                        transition: 0.5s all;

                        .logoBtn {
                            font-weight: bold;
                            font-size: 16px;
                            color: #ffffff;
                            line-height: 24px;
                            text-align: left;
                            width: 100%;
                            height: 44px;
                            background: #d61818;
                            border-radius: 5px 5px 5px 5px;
                        }

                        .blackLine {
                            width: 100%;
                            height: 2px;
                            background: #000000;
                            opacity: 0.2;
                            margin: 28px 0;
                        }

                        .hintText {
                            font-weight: 400;
                            font-size: 14px;
                            color: #000000;
                            line-height: 24px;
                            margin-bottom: 14px;
                        }

                        .signBtn {
                            width: 100%;
                            height: 44px;
                            border-radius: 5px 5px 5px 5px;
                            border: 1px solid #d61818;
                            font-weight: bold;
                            font-size: 16px;
                            color: #000000;
                            line-height: 24px;
                        }
                    }

                    &:hover {
                        background: #fff;

                        .btnText {
                            color: #000;
                        }

                        .downIcon {
                            display: none;
                        }

                        .downIcon2 {
                            display: block;
                        }

                        .btnWin {
                            display: block;
                        }

                        .btnWin2 {
                            display: block;
                        }
                    }
                }

                .whiteLine {
                    width: 2px;
                    height: 16px;
                    opacity: 0.6;
                    margin: 0 16px;
                    background: #ffffff;
                }

                .whiteLine2 {
                    width: 2px;
                    height: 16px;
                    opacity: 0.6;
                    margin: 0 16px 0 0;
                    background: #ffffff;
                }

                .textBtn {
                    font-weight: bold;
                    font-size: 14px;
                    color: #ffffff;
                    line-height: 20px;
                    text-align: left;
                    cursor: pointer;
                }
            }

            .leftBox {
                height: 100%;

                .btnBigBox {
                    height: 100%;
                    position: relative;
                    cursor: pointer;
                    padding: 0 18px;

                    .btnText {
                        font-weight: bold;
                        font-size: 15px;
                        color: #ffffff;
                        line-height: 20px;
                    }

                    .downIcon {
                        width: 14px;
                        display: block;
                        margin-left: 4px;
                    }

                    .downIcon2 {
                        width: 14px;
                        display: none;
                        margin-left: 4px;
                    }

                    &.active {
                        background: #fff;

                        .btnText {
                            color: #000000;
                        }

                        .downIcon {
                            display: none;
                        }

                        .downIcon2 {
                            display: block;
                        }
                    }
                }
            }
        }
    }

    .searchBigBox {
        height: 108px;
        background: #ffffff;

        .searchLeftBox {
            display: flex;
            align-items: center;
        }

        .logo {
            width: 126px;
            display: block;
            margin-right: 140px;
            cursor: pointer;
        }

        .searchBarBox {
            width: 760px;
            height: 48px;
            border-radius: 4px;
            box-sizing: border-box;
            border: 1px solid #949494;
            z-index: 10;

            .leftBox {
                height: 100%;
                padding-right: 30px;
                position: relative;

                .searchWin {
                    width: 100%;
                    background: #ffffff;
                    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                    position: absolute;
                    top: 48px;
                    left: 0;
                    padding: 10px 12px;

                    .redText {
                        width: fit-content;
                        font-weight: bold;
                        font-size: 14px;
                        color: #d61818;
                        line-height: 19px;
                        text-align: left;
                        cursor: pointer;
                    }

                    .hintText {
                        width: 100%;
                        font-weight: bold;
                        font-size: 14px;
                        color: #000000;
                        line-height: 19px;
                        text-align: left;
                        margin-bottom: 6px;
                    }

                    .hintText2 {
                        width: 100%;
                        font-weight: bold;
                        font-size: 14px;
                        color: #000000;
                        line-height: 19px;
                        text-align: left;
                    }

                    .winGreyLine {
                        width: 100%;
                        height: 2px;
                        background: #949494;
                        opacity: 0.5;
                        margin: 8px 0;
                    }

                    .searchText {
                        width: 100%;
                        cursor: pointer;
                        font-weight: 400;
                        font-size: 14px;
                        color: #000000;
                        line-height: 19px;
                        text-align: left;
                        padding: 5px;

                        &:hover {
                            background: rgba(214, 24, 24, 0.2);
                        }
                    }
                }

                .inputStyle {
                    font-weight: 400;
                    font-size: 14px;
                    color: #494949;
                    line-height: 20px;
                }

                .lineGrey {
                    width: 1px;
                    height: 22px;
                    background: #949494;
                    margin-right: 14px;
                }

                .selectBox {
                    width: 100px;
                    height: 100%;
                    padding: 0 10px;
                    cursor: pointer;
                    z-index: 9;
                    position: relative;

                    .text {
                        font-weight: 400;
                        font-size: 14px;
                        color: #000000;
                        line-height: 20px;
                        text-align: center;
                        margin-right: 4px;
                        position: relative;
                    }

                    .itemBoxInput {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        opacity: 0;
                        cursor: pointer;
                    }

                    .icon {
                        font-size: 14px;
                        color: #d61818;
                    }

                    .selectBigBox {
                        width: 100px;
                        background: #ffffff;
                        border-radius: 3px 3px 3px 3px;
                        border: 1px solid #949494;
                        position: absolute;
                        top: 46px;
                        left: 0;
                        // display: none;
                        padding: 4px 0;

                        .itemBox {
                            width: 100%;
                            height: 30px;
                            font-weight: 400;
                            font-size: 14px;
                            color: #000000;
                            line-height: 19px;
                            text-align: left;
                            padding: 0 10px;
                            position: relative;

                            &:hover,
                            &.active {
                                background: #ffdbdb;
                            }
                        }
                    }

                    // &:hover {
                    //     .selectBigBox {
                    //         display: block;
                    //     }
                    // }
                }
            }

            .searchIconBox {
                width: 60px;
                height: 48px;
                background: #d61818;
                cursor: pointer;
                border-radius: 0 4px 4px 0;

                .icon {
                    font-size: 26px;
                    color: #ffffff;
                }
            }
        }

        // 语言选择器样式
        .languageSelectorWrapper {
            display: flex;
            align-items: center;
            position: relative;

            .countrySelector {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #DA291C;
                font-weight: 400;

                .languageIcon {
                    width: 20px;
                    height: 20px;
                    margin-right: 6px;
                    fill: #DA291C;
                }
            }

            .languageDivider {
                width: 1px;
                height: 20px;
                background: #DA291C;
                margin: 0 12px;
            }

            .languageSelectorBtn {
                display: flex;
                align-items: center;
                padding: 6px 12px;
                background: transparent;
                border: none;
                border-radius: 0;
                cursor: pointer;
                font-size: 14px;
                color: #DA291C;
                font-weight: 400;
                transition: all 0.3s;

                .arrowIcon {
                    width: 16px;
                    height: 16px;
                    margin-left: 6px;
                    fill: #DA291C;
                    transition: transform 0.3s;
                }

                &:hover {
                    background: transparent;
                    opacity: 0.8;
                }
            }

            .languageMenu {
                position: absolute;
                top: 100%;
                right: 0;
                margin-top: 8px;
                background: #ffffff;
                border: 1px solid #949494;
                border-radius: 4px;
                box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                min-width: 150px;
                z-index: 1000;
                padding: 4px 0;

                .languageMenuItem {
                    padding: 10px 16px;
                    font-size: 14px;
                    color: #000000;
                    cursor: pointer;
                    transition: background 0.2s;

                    &:hover {
                        background: #ffdbdb;
                    }

                    &.active {
                        background: #ffdbdb;
                        font-weight: bold;
                        color: #d61818;
                    }
                }
            }
        }
    }
}
</style>
